jQuery(document).ready(function () {

    function createCookie(name, value, days)
    {
        var date,
            expires;

        if (days) {
            date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

            expires = '; expires=' + date.toGMTString();
        } else {
            expires = '';
        }

        document.cookie = name + '=' + value + expires + '; path=/';
    }

    function readCookie(name)
    {
        const expectedCookieNamePrefix = name + '=';
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];

            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1, cookie.length);
            }

            if (cookie.indexOf(expectedCookieNamePrefix) === 0) {
                return cookie.substring(expectedCookieNamePrefix.length, cookie.length);
            }
        }

        return null;
    }

    const cookieName = "_dark_page_";

    // Do not show dark page dialog when cookie was set.
    if (readCookie(cookieName) === 'viewed') {
        return;
    }

    // find dark page element (if any)
    let $el = jQuery(".dark-page-dialog");
    if ($el.length === 0) {
        return;
    }

    // Show dark page dialog.
    $el.on('click', '.dialog-close-button', function(ev) {
        ev.delegateTarget.close();
        createCookie(cookieName, 'viewed', 0);
    });
    $el.get(0).showModal(); // Currently only one dialog is supported!

});
